import { route } from "react-router-typesafe-routes/dom";

export const serverLocations = route(
  "server",
  {},
  {
    Dashboard: route(""),
  }
);
